<template>
  <v-select
    v-model="selected"
    :items="computedCategories"
    item-text="name"
    item-value="id"
    :label="__('Anexos')"
    :loading="loading"
    :disabled="loading"
    :multiple="isCreateMode"
    :placeholder="
      categories.length === 0 ? __('Nenhuma categoria disponível') : ''
    "
    @change="handleChange"
  >
    <template v-if="isCreateMode" v-slot:prepend-item>
      <v-list-item ripple @click="toggleSelectAll">
        <v-list-item-action>
          <v-checkbox
            :input-value="selectAllState === 'all'"
            :indeterminate="selectAllState === 'partial'"
            color="primary"
          />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ __("Selecionar todos") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
    </template>
  </v-select>
</template>

<script>
import i18n from "@/mixins/i18n";
import { listRequestedDocumentTypes } from "@/services/requested_documents_types";

export default {
  name: "SelectRequestedDocumentTypeBySubtype",
  mixins: [i18n],

  props: {
    leadTypeId: {
      type: [String, Number],
      default: null,
    },
    subtypeId: {
      type: [String, Number],
      default: null,
    },
    value: { type: [Array, Number, String, null], default: () => [] },
    excludedCategoryIds: { type: Array, default: () => [] },
    isCreateMode: { type: Boolean, default: false },
  },

  data() {
    return {
      i18n_prefix: "requested_documents",
      categories: [],
      loading: false,
      selected: this.isCreateMode
        ? Array.isArray(this.value)
          ? [...this.value]
          : []
        : this.value ?? null,
    };
  },

  computed: {
    filteredCategories() {
      return this.categories.filter(
        (cat) => !this.excludedCategoryIds.includes(cat.id)
      );
    },

    filteredCategoryIds() {
      return this.filteredCategories.map((c) => c.id);
    },

    computedCategories() {
      return this.filteredCategories;
    },

    selectAllState() {
      if (!this.isCreateMode) return null;
      const sel = Array.isArray(this.selected) ? this.selected : [];
      if (sel.length === 0) return "none";
      if (this.filteredCategoryIds.every((id) => sel.includes(id)))
        return "all";
      return "partial";
    },
  },

  watch: {
    value(val) {
      if (this.isCreateMode) {
        this.selected = Array.isArray(val) ? [...val] : [];
      } else {
        this.selected = val ?? null;
      }
    },
    subtypeId: {
      handler() {
        this.loadCategories();
      },
      immediate: true,
    },
    leadTypeId: {
      handler() {
        this.loadCategories();
      },
      immediate: true,
    },
  },

  methods: {
    async loadCategories() {
      this.loading = true;
      try {
        const response = await listRequestedDocumentTypes(
          this.leadTypeId,
          this.subtypeId
        );
        this.categories = Array.isArray(response.data) ? response.data : [];
      } finally {
        this.loading = false;
      }
    },

    toggleSelectAll() {
      if (this.selectAllState === "all") {
        this.selected = [];
      } else {
        this.selected = [...this.filteredCategoryIds];
      }
      this.emitSelection();
    },

    handleChange() {
      this.emitSelection();
    },

    emitSelection() {
      if (this.isCreateMode) {
        this.$emit(
          "input",
          Array.isArray(this.selected) ? [...this.selected] : []
        );
      } else {
        this.$emit("input", this.selected ?? null);
      }
    },
  },
};
</script>
